import { render } from "./TableFieldsList.vue?vue&type=template&id=d81074e6"
import script from "./TableFieldsList.vue?vue&type=script&lang=js"
export * from "./TableFieldsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__